import React from "react";

function header(props) {
  return (
    <section className="mannkibaatquiz_bg">
      <div className="">
        <div className="mannkibaatquiz_heading">
          {/* <h3>{props.title || "Mann Ki Baat Quiz"}</h3> */}
        </div>
      </div>
    </section>
  );
}

export default header;
